(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

  		$('.trusler-block--area-collage').each( function(i, el) {

		   	const grid = $(el).find('.collage-list').packery({
			  	itemSelector: '.collage-item',
				columnWidth: '.collage-sizer',
				gutter: '.gutter-sizer',				
				percentPosition: true,	
				transitionDuration: '0.2s',
				stagger: 30,
				originLeft: true,	  	
			});		

		   	$(window).ready(function($) {

		   		setTimeout( function() {

					list = el.querySelector('.collage-list');
					ParcelFunctions.inViewport(list, 0.3, 0.15, 'list-in-viewport');

		   		}, 250);

		   	})

		})

	});

})(jQuery);